import React from 'react';
import { hesitations } from '../data/content';
import { LeafSprig } from './decor/LeafSprig';
export function Problem() {
  return <section aria-labelledby="problem-title" className="bg-paper" data-id="element-228" data-mp="2peyz4ik9xwg9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-229" data-mp="2bgisermew5y4">
        <h2 id="problem-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[38px] leading-[1.05] text-navy sm:text-[54px]" data-id="element-230" data-mp="2gesnl284z6jq">
          Wie viele Samen des Glaubens hast du diese Woche gesät?
        </h2>

        <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-231" data-mp="26hocbxftwvhp">
          <div className="space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-232" data-mp="1sphvsa8rkmhq">
            <p className="font-display text-2xl leading-snug text-navy sm:text-[28px]" data-id="element-233" data-mp="1sn57zggbrhwr">Jesus hat uns aufgetragen, hinzugehen und Menschen zu Jüngern zu machen.</p>
            <p data-id="element-234" data-mp="1isd7o4vcygya">
              Doch manchmal vergeht einfach noch ein Tag.
              <br data-id="element-235" data-mp="1nqojum94l3jo" />
              Und dann noch eine Woche.
            </p>
            <p data-id="element-236" data-mp="t9x1r49qa41s">Wir gehen zur Arbeit. Wir kaufen ein. Wir sind in Geschäften unterwegs. Wir reden mit unseren Nachbarn. Wir begegnen überall Menschen …</p>
            <p className="border-l-4 border-coral pl-5 font-bold text-navy" data-id="element-237" data-mp="oac4cya7i3r6">Und trotzdem lassen wir wieder eine Gelegenheit verstreichen, von Jesus zu erzählen.</p>
          </div>

          <div data-id="element-238" data-mp="xclehn1kbv41">
            <p className="text-lg leading-relaxed text-ink-soft" data-id="element-239" data-mp="xcto962e2kb0">
              Vielleicht möchtest du von Herzen gern evangelisieren – aber jedes Mal, wenn sich eine Gelegenheit ergibt, denkst du:
            </p>
            <ul className="mt-6 flex flex-wrap gap-3" data-id="element-240" data-mp="5m74i1wo72xn">
              {hesitations.map(h => <li key={h} className="rounded-2xl rounded-bl-sm bg-white px-5 py-3 font-display text-xl text-ink-soft shadow-card ring-1 ring-cream-line" data-id="element-241" data-mp="jd25yt4uahr7">
                  „{h}“
                </li>)}
            </ul>
            <p className="mt-8 text-lg leading-relaxed text-ink-soft" data-id="element-242" data-mp="3i1r8aahbkceh">
              Und ohne dass du es merkst, ist dein Alltag zum Grund geworden, warum du den Auftrag, den Gott dir längst gegeben hat, immer wieder
              aufschiebst.
            </p>
          </div>
        </div>

        <div className="relative mx-auto mt-16 max-w-3xl rounded-[28px] bg-leaf-wash px-6 py-12 text-center sm:px-12" data-id="element-243" data-mp="1qvcyhmlnwzrz">
          <LeafSprig className="mx-auto h-16 w-8 text-leaf-deep" data-id="element-244" data-mp="20n95jn5q808c" />
          <p className="mt-4 text-lg font-semibold text-navy sm:text-xl" data-id="element-245" data-mp="20plljurxc0ir">Doch das Evangelium weiterzugeben beginnt nicht immer mit einer Predigt.</p>
          <p className="mt-3 font-display text-3xl leading-tight text-navy sm:text-[42px]" data-id="element-246" data-mp="17y2167jlcgf6">
            Manchmal … beginnt alles mit <span className="italic text-leaf-deep" data-id="element-247" data-mp="1cx51xfsjg0hc">einem kleinen Samenkorn.</span>
          </p>
        </div>
      </div>
    </section>;
}